import React from 'react';
import { FiLock, FiExternalLink } from 'react-icons/fi';
import { useLocalStorageState } from '../../hooks/useLocalStorageState';
import { Icon } from '../ui/Icon';

type AgeState = 'unknown' | 'yes' | 'no';

const AGE_KEY = 'lbf_age_state';

export function AgeGate() {
  const [ageState, setAgeState] = useLocalStorageState<AgeState>(AGE_KEY, 'unknown');

  if (ageState === 'yes') return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/70 p-4 backdrop-blur">
      <div className="w-full max-w-xl overflow-hidden rounded-3xl border border-white/10 bg-zinc-950 shadow-glow">
        <div className="relative p-6 sm:p-8">
          <div className="absolute inset-0 bg-radial-fade-2 opacity-70" />
          <div className="relative">
            <div className="flex items-center gap-3">
              <div className="grid h-11 w-11 place-items-center rounded-2xl border border-white/10 bg-white/5">
                <Icon icon={FiLock} className="text-lg text-white" aria-hidden="true" />
              </div>
              <div>
                <div className="text-sm font-extrabold tracking-wide text-white">Vérification d’âge</div>
                <div className="text-xs text-zinc-300/80">Accès réservé aux 18 ans et plus</div>
              </div>
            </div>

            {ageState === 'no' ? (
              <div className="mt-6">
                <p className="text-sm text-zinc-200/90">
                  L’accès à ce contenu est bloqué. Si tu t’es trompé, tu peux relancer la vérification.
                </p>
                <div className="mt-5 flex flex-col gap-2 sm:flex-row">
                  <button type="button" className="lbf-btn-primary" onClick={() => setAgeState('unknown')}>
                    Refaire la vérification
                  </button>
                  <a
                    className="lbf-btn-ghost"
                    href="https://www.service-public.fr/particuliers/vosdroits/F1698"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Infos officielles <Icon icon={FiExternalLink} aria-hidden="true" />
                  </a>
                </div>
              </div>
            ) : (
              <div className="mt-6">
                <p className="text-sm text-zinc-200/90">
                  Confirme ton âge pour accéder aux comparatifs d’offres et aux analyses. On reste sobre: pas de spam,
                  pas de promesses irréalistes — seulement des conditions claires.
                </p>
                <div className="mt-5 flex flex-col gap-2 sm:flex-row">
                  <button type="button" className="lbf-btn-primary" onClick={() => setAgeState('yes')}>
                    J’ai 18 ans ou plus
                  </button>
                  <button type="button" className="lbf-btn-ghost" onClick={() => setAgeState('no')}>
                    Je n’ai pas 18 ans
                  </button>
                </div>
                <p className="mt-4 text-xs text-zinc-400/90">
                  En continuant, tu confirmes respecter l’âge légal en France. Jeu responsable recommandé.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}


